import { Moment } from 'moment';

export enum ConsultDfe {
  nsu = 'NSU',
  nsuUnique = 'NSU_UNICO',
  chave = 'CHAVE',
}

export interface DesignatedNotesRequest {
  companyId: number;
  consultaDFeEnum: ConsultDfe;
  chaveNsu: string;
}

export interface DesignatedNotesFormValues {
  companyId: number;
  consultDFeEnum: ConsultDfe;
  nsuKey: string;
}

export enum ManifestNotesType {
  confirmedOperation = 'CONFIRMED_OPERATION',
  confirmed = 'CONFIRMED',
  unknown = 'UNKNOWN',
  notExecuted = 'NOT_EXECUTED',
}

export interface ManifestNotesFormValues {
  type: ManifestNotesType;
  reason: string;
}

interface ManifestItem {
  reason: string;
  recipientInvoiceId: number;
  type: ManifestNotesType;
}

export interface ManifestNotesRequest {
  companyId: number;
  eventDh: string;
  manifestarRequestDTO: ManifestItem[];
}

export enum InutilizationNumberRequestDocumentType {
  NFE = 'NFE',
  NFCE = 'NFCE',
}

export interface InutilizationNumberRequest {
  companyId: number;
  documentType: InutilizationNumberRequestDocumentType;
  endNumber: number;
  justification: string;
  series: number;
  startNumber: number;
}

export interface InvoiceAllXmlRequest {
  companyId: number;
  startDate: string;
  endDate: string;
}

export interface InvoiceAllXmlForm
  extends Omit<InvoiceAllXmlRequest, 'startDate' | 'endDate'> {
  startDate: Moment;
  endDate: Moment;
}

export interface InvoiceAllPDfRequest {
  companyId: number;
  startDate: string;
  endDate: string;
}
